import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'TryOurApp',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Object,
    default: () => ({}),
  },
  small: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return { __sfc: true, }
}

})